import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import axiosInstance from '../api/axiosInstance'
import Swal from 'sweetalert2'

const COLORS = { gray: '#5B6B79', blue: '#96C5F7', green: '#2CA87F', red: '#9E2B25' }
const thStyle = { fontSize: 11, fontWeight: 700, color: COLORS.gray, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '8px 10px', background: '#f8f9fb', borderBottom: '1px solid #e8ecf0', whiteSpace: 'nowrap' }
const tdStyle = { fontSize: 13, color: '#2d3748', padding: '7px 10px', verticalAlign: 'middle', borderBottom: '1px solid #f0f2f5' }
const SearchBox = ({ value, onChange }) => (
  <div style={{ position: 'relative', maxWidth: 260 }}>
    <i className="ti ti-search" style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: COLORS.gray, fontSize: 14, pointerEvents: 'none' }} />
    <input type="text" value={value} onChange={onChange} placeholder="Search..." style={{ paddingLeft: 32, paddingRight: 10, height: 34, fontSize: 13, border: '1px solid #dde3eb', borderRadius: 8, width: '100%', outline: 'none', color: COLORS.gray }} />
  </div>
)

const TABLE = 'history_of_past_illness'

export default function Hisstoryodpastillness() {
  const navigate = useNavigate()
  const [items, setItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [search, setSearch] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [editItem, setEditItem] = useState(null)
  const [text, setText] = useState('')
  const [saving, setSaving] = useState(false)

  const fetchItems = () => {
    setIsLoading(true)
    axiosInstance.get(`getAllTablesText?table=${TABLE}`)
      .then(res => setItems(res.data?.data || []))
      .catch(() => Swal.fire('Error', 'Failed to load items', 'error'))
      .finally(() => setIsLoading(false))
  }
  useEffect(() => { fetchItems() }, [])

  const filtered = items.filter(i => i.text?.toLowerCase().includes(search.toLowerCase()))
  const openAdd = () => { setEditItem(null); setText(''); setModalOpen(true) }
  const openEdit = item => { setEditItem(item); setText(item.text || ''); setModalOpen(true) }
  const closeModal = () => { setModalOpen(false); setEditItem(null); setText('') }

  const handleSave = async () => {
    if (!text.trim()) { Swal.fire('Validation', 'Field cannot be empty', 'warning'); return }
    setSaving(true)
    try {
      if (editItem) {
        await axiosInstance.put(`editAllTableText/${editItem.id}?table=${TABLE}`, { text })
      } else {
        await axiosInstance.post(`createAllTableText?table=${TABLE}`, { text })
      }
      Swal.fire('Success', editItem ? 'Updated successfully' : 'Added successfully', 'success')
      closeModal(); fetchItems()
    } catch (err) {
      Swal.fire('Error', err.response?.data?.message || 'Failed to save', 'error')
    } finally { setSaving(false) }
  }

  const handleDelete = id => {
    Swal.fire({ title: 'Are you sure?', text: 'This item will be deleted.', icon: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!' })
      .then(result => {
        if (result.isConfirmed)
          axiosInstance.delete(`deleteAllTablesText/${id}?table=${TABLE}`)
            .then(() => { Swal.fire('Deleted!', 'Item deleted.', 'success'); fetchItems() })
            .catch(() => Swal.fire('Error', 'Failed to delete', 'error'))
      })
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', overflow: 'hidden' }}>
          <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={() => navigate(-1)} title="Go back" style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e8ecf0', background: '#f8f9fb', color: COLORS.gray, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4, flexShrink: 0 }} onMouseEnter={e => { e.currentTarget.style.background = COLORS.blue + '22'; e.currentTarget.style.color = COLORS.blue }} onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = COLORS.gray }}><i className="ti ti-arrow-left" /></button>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: `${COLORS.blue}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="ti ti-clock" style={{ color: COLORS.blue, fontSize: 17 }} /></div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>History of Past Illness</div>
              <div style={{ fontSize: 11, color: COLORS.gray }}>Manage past illness history options</div>
            </div>
          </div>
          <div style={{ padding: '10px 20px', borderBottom: '1px solid #e8ecf0', background: '#fafbfc', display: 'flex', alignItems: 'center', gap: 8 }}>
            <button className="bgBtn btn-sm d-flex align-items-center gap-1" style={{ fontSize: 13, padding: '5px 12px' }} onClick={openAdd}><i className="ti ti-plus" style={{ fontSize: 15 }} /> Add Item</button>
          </div>
          <div style={{ padding: '14px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
              <SearchBox value={search} onChange={e => setSearch(e.target.value)} />
              <span style={{ fontSize: 11, color: COLORS.gray }}>{filtered.length} item{filtered.length !== 1 ? 's' : ''}</span>
            </div>
            <div style={{ overflowX: 'auto', borderRadius: 8, border: '1px solid #e8ecf0' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ ...thStyle, width: 50, borderLeft: `3px solid ${COLORS.blue}` }}>#</th>
                    <th style={thStyle}>History of Past Illness</th>
                    <th style={{ ...thStyle, width: 120, textAlign: 'center' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && <tr><td colSpan={3} style={{ ...tdStyle, textAlign: 'center', padding: '32px 0', color: COLORS.gray }}><i className="ti ti-loader-2" style={{ fontSize: 22, display: 'block', marginBottom: 6, opacity: 0.5 }} />Loading...</td></tr>}
                  {!isLoading && filtered.length === 0 && <tr><td colSpan={3} style={{ ...tdStyle, textAlign: 'center', padding: '32px 0', color: COLORS.gray }}><i className="ti ti-database-off" style={{ fontSize: 28, display: 'block', marginBottom: 6, opacity: 0.4 }} />No items found</td></tr>}
                  {!isLoading && filtered.map((item, i) => (
                    <tr key={item.id} style={{ background: i % 2 === 0 ? '#fff' : '#fafbfc' }} onMouseEnter={e => e.currentTarget.style.background = `${COLORS.blue}0d`} onMouseLeave={e => e.currentTarget.style.background = i % 2 === 0 ? '#fff' : '#fafbfc'}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={{ ...tdStyle, fontWeight: 500 }}>{item.text}</td>
                      <td style={{ ...tdStyle, textAlign: 'center' }}>
                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                          <button onClick={() => openEdit(item)} title="Edit" style={{ width: 30, height: 30, borderRadius: 8, border: 'none', cursor: 'pointer', background: `${COLORS.blue}22`, color: COLORS.blue, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }} onMouseEnter={e => e.currentTarget.style.background = COLORS.blue + '44'} onMouseLeave={e => e.currentTarget.style.background = COLORS.blue + '22'}><i className="ti ti-edit" /></button>
                          <button onClick={() => handleDelete(item.id)} title="Delete" style={{ width: 30, height: 30, borderRadius: 8, border: 'none', cursor: 'pointer', background: `${COLORS.red}18`, color: COLORS.red, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }} onMouseEnter={e => e.currentTarget.style.background = COLORS.red + '33'} onMouseLeave={e => e.currentTarget.style.background = COLORS.red + '18'}><i className="ti ti-trash" /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {modalOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.35)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 40, overflowY: 'auto' }} onClick={closeModal}>
          <div style={{ background: '#fff', borderRadius: 12, width: '90%', maxWidth: 480, boxShadow: '0 8px 32px rgba(0,0,0,0.18)', marginBottom: 40 }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '18px 24px', borderBottom: '1px solid #e8ecf0' }}>
              <div style={{ width: 34, height: 34, borderRadius: 8, background: `${COLORS.blue}20`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><i className="ti ti-clock" style={{ color: COLORS.blue, fontSize: 18 }} /></div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>{editItem ? 'Edit Past Illness' : 'Add Past Illness'}</div>
                <div style={{ fontSize: 11, color: COLORS.gray }}>{editItem ? 'Update this item' : 'Add a new item to the list'}</div>
              </div>
              <button onClick={closeModal} style={{ marginLeft: 'auto', width: 26, height: 26, borderRadius: 6, border: '1px solid #e8ecf0', background: '#f8f9fb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: COLORS.gray, fontSize: 14 }}><i className="ti ti-x" /></button>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: COLORS.gray, display: 'block', marginBottom: 6 }}>History of Past Illness <span style={{ color: '#e53e3e' }}>*</span></label>
              <input type="text" value={text} onChange={e => setText(e.target.value)} placeholder="Enter past illness..." style={{ width: '100%', height: 38, borderRadius: 8, border: '1.5px solid #dde3eb', padding: '0 12px', fontSize: 14, color: '#1a202c', outline: 'none' }} onFocus={e => e.target.style.borderColor = COLORS.blue} onBlur={e => e.target.style.borderColor = '#dde3eb'} onKeyDown={e => e.key === 'Enter' && handleSave()} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', padding: '14px 24px', borderTop: '1px solid #e8ecf0' }}>
              <button onClick={closeModal} style={{ padding: '7px 16px', fontSize: 13, borderRadius: 8, border: '1px solid #dde3eb', background: '#f8f9fb', color: COLORS.gray, cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleSave} disabled={saving} className="bgBtn btn-sm d-flex align-items-center gap-1" style={{ padding: '7px 18px', fontSize: 13 }}>
                {saving && <i className="ti ti-loader-2" style={{ fontSize: 14 }} />}{saving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
